module.exports = __webpack_public_path__ + "static/img/Secp-logo.bff4cf5.bff4cf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Secp-logo.bff4cf5.png
// module id = G987
// module chunks = 1